// import { configureStore } from "@reduxjs/toolkit";
// import sideNavPosition from "./Reducers/sideNavPosition";
// import loggedInUserDetails from "./Reducers/loggedInUserDetails";
// import userSelectedRoles from "./Reducers/userSelectedRoles";
// import transactionIDS from "./Reducers/transactionIDS";
// import signInUserData from "./Reducers/signInUserData";
// import applicantsView from "./Reducers/applicantsView";
// import courseProgressModal from "./Reducers/courseProgressModal";
// import useReducer from "../../../redux/useReducer";
// import useTrainingReducer from './Reducers/onGoingTrainingsChecker';

// export const store = configureStore({
//   reducer: {
//     navStatus: sideNavPosition,
//     login: loggedInUserDetails,
//     roles: userSelectedRoles,
//     transaction: transactionIDS,
//     signInInput: signInUserData,
//     applicants: applicantsView,
//     courseprogress: courseProgressModal,
//     user: useReducer,
//     training: useTrainingReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({ serializableCheck: false }),
// });

// export type State = ReturnType<typeof store.getState>;
// export type Dispatch = typeof store.dispatch;

import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import sideNavPosition from "./Reducers/sideNavPosition";
import loggedInUserDetails from "./Reducers/loggedInUserDetails";
import userSelectedRoles from "./Reducers/userSelectedRoles";
import transactionIDS from "./Reducers/transactionIDS";
import signInUserData from "./Reducers/signInUserData";
import applicantsView from "./Reducers/applicantsView";
import courseProgressModal from "./Reducers/courseProgressModal";
import useReducer from "../../../redux/useReducer";
import useTrainingReducer from './Reducers/onGoingTrainingsChecker';

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["training"], // Only persist the training reducer
};

const rootReducer = {
  navStatus: sideNavPosition,
  login: loggedInUserDetails,
  roles: userSelectedRoles,
  transaction: transactionIDS,
  signInInput: signInUserData,
  applicants: applicantsView,
  courseprogress: courseProgressModal,
  user: useReducer,
  training: useTrainingReducer,
};

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

export type State = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;